export const ABOUT_US = 'Про нас';
export const MENU = 'Меню';
export const HIPPOTHERAPY = 'Іпотерапія';

export const REPORTING = 'Звітність';
export const STORE = 'Крамниця';
export const HOW_TO_SUPPORT = 'Як підтримати';
export const STORIES_OF_VICTORIES = 'Історії перемог';

export const OUR_HISTORY = 'Наша історія';
export const OUR_TEAM = 'Наша команда';
export const PARTNERS = 'Партнери';
export const EVENTS_AND_NEWS = 'Події та новини';

export const WHAT_IS_HIPPOTHERAPY = 'Що таке іпотерапія';
export const PROGRAMS = 'Програми';
export const PROGRAMS_SESSIONS = 'Сесії програм';

export const VICTORY_STARTS_WITH_YOU = 'ПЕРЕМОГА ПОЧИНАЄТЬСЯ З ТЕБЕ';

export const STAY_UP_TO_DATE_WITH_THE_NEWS = 'Будьте в курсі новин та можливостей';
export const ENTER_YOUR_EMAIL = 'Вкажіть ваш Email';
export const SIGN_UP = 'Підписатися';

export const EMAIL = 'victorycenter@gmail.com';
export const PHONE = '+380 50 334 4448';
export const FACEBOOK = 'https://www.facebook.com/victorycenterua';
export const INSTAGRAM = 'https://www.instagram.com/victorycenterua';
export const TELEGRAM = 'https://t.me/victorycenterua';
